import {Injectable} from "@angular/core";
import {Actions, createEffect, CreateEffectMetadata, ofType} from '@ngrx/effects';
import * as dataSourceDimensions from "./dataSourceDimensions.actions";
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {map} from "rxjs/operators";
import {Serializer, SerializerResponse, Serializers} from '../../interfaces/serializer';
import {DimensionsService} from '../../services/dimensions.service';
import {TypedAction} from '@ngrx/store/src/models';
import {Store} from '@ngrx/store';
import {AppState} from '../store';
import {selectSite} from '../init/init.selectors';
import {Site} from '../../interfaces/site';
import {DataSourceDimension} from '../../interfaces/dimensions';

@Injectable()
export class DataSourceDimensionsEffects {

  private readonly _load$: Observable<TypedAction<string> & { dataSourcesDimensions: Serializers<DataSourceDimension> }> & CreateEffectMetadata = createEffect(() => this._actions$
    .pipe(
      ofType(dataSourceDimensions.loadDataSourceDimensions),
      withLatestFrom(this._store.select(selectSite)),
      switchMap(([_, dataset]: [TypedAction<string>, Serializer<Site>]): Observable<SerializerResponse<Serializers<DataSourceDimension>>> => this._dimensionsService.getDataSourcesDimensions(dataset)),
      map((response: SerializerResponse<Serializers<DataSourceDimension>>): TypedAction<string> & any => dataSourceDimensions.loadDataSourceDimensionsSuccess({ dimensions: response.data }))
    )
  );

  constructor(
    private readonly _actions$: Actions,
    private readonly _dimensionsService: DimensionsService,
    private readonly _store: Store<AppState>
  ) {}
}
